<section id="stc-dates">
    <div class="container">
        <div class="row" data-aos="fade-down" data-aos-easing="ease"  data-aos-duration="2000">
            <div class="col-md-12 d-flex justify-content-center flex-column text-center" >
                <img src="/assets/images/sorteo2025/img-feha.png" alt="" class="img-fluid">
            </div>
        </div>
    </div>
</section>


<section class="stc-days" data-aos="zoom-in" data-aos-easing="ease"  data-aos-duration="2000">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <div class="row">
                    <!-- <div class="col-12">
                        <h5 class="">Alumnos de reingreso</h5>
                    </div>
                    <div class="col-md-7">
                        <p class="day">
                            Primer corte de pago
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            15 de mayo
                        </p>
                    </div>

                    <div class="col-md-7">
                        <p class="day">
                            Fecha límite de pago
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            28 de agosto
                        </p>
                    </div>

                    <div class="col-md-7">
                        <p class="day">
                            Sorteo Magno
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            21 de noviembre
                        </p>
                    </div>

                    <div class="col-12">
                        <h5 class="">Alumnos a egresar en Mayo</h5>
                    </div>
                    <div class="col-md-7">
                        <p class="day">
                            Fecha límite de pago
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            15 de mayo
                        </p>
                    </div>

                    <div class="col-12">
                        <h5 class="">Alumnos nuevo ingreso</h5>
                    </div>
                    <div class="col-md-7">
                        <p class="day">
                            Primer corte de pago
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            7 de octubre
                        </p>
                    </div>
                    <div class="col-md-7">
                        <p class="day">
                            Fecha límite
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            15 de octubre
                        </p>
                    </div>

                    <div class="col-12">
                        <h5 class="">Comunidad Universitaria Voluntaria</h5>
                    </div>
                    <div class="col-md-7">
                        <p class="day">
                            Fecha límite de pago
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            7 de octubre
                        </p>
                    </div> -->


                    <div class="col-lg-9">
                        <h5>
                            Fechas de Sorteos Oportunos
                        </h5>
                    </div>

                    <div class="col-md-7">
                        <p class="day">
                            1° SORTEO OPORTUNO
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            Corte participantes físico: 19 de mayo
                        </p>
                        <p>
                            Corte participantes digital: 22 de mayo
                        </p>
                        <p>
                            23 de mayo 11:15 <br> Sede: Universidad Anáhuac México Campus Norte
                        </p>
                    </div>

                    <div class="col-md-7">
                        <p class="day">
                            2° SORTEO OPORTUNO
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            Corte participantes físico: 19 de agosto
                        </p>
                        <p>
                            Corte participantes digital: 21 de agosto
                        </p>
                        <p>
                            22 de agosto 11:15 <br> Sede: Universidad Anáhuac México Campus Sur
                        </p>
                    </div>


                    <div class="col-md-7">
                        <p class="day">
                            3° SORTEO OPORTUNO
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            Corte participantes físico: 13 de octubre
                        </p>
                        <p>
                            Corte participantes digital: 16 de octubre
                        </p>
                        <p>
                            17 de octubre 11:15<br>Sede: Universidad Anáhuac México Campus Sur
                        </p>
                    </div>

                    <div class="col-md-7">
                        <p class="day">
                            FECHAS DE SORTEO MAGNO
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            20 de noviembre de 2025.
                        </p>
   
                    </div>


                    
                    <div class="col-lg-9">
                        <h5>
                            FECHAS LÍMITE DE PAGO - COMUNIDAD ANÁHUAC
                        </h5>
                    </div>

                    <div class="col-md-7">
                        <p class="day text-uppercase">
                            Alumnos de Reingreso (RI)
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            Primer corte de pago: 15 de mayo de 2025
                        </p>
                        <p>
                            Fecha límite de pago: 28 de agosto de 2025
                        </p>
   
                    </div>

                    <div class="col-md-7">
                        <p class="day text-uppercase">
                            Comunidad Universitaria
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            Primer corte de pago: 12 de agosto de 2025
                        </p>
                        <p>
                            Segundo corte de pago: 14 de octubre de 2025
                        </p>
   
                    </div>

                    <div class="col-md-7">
                        <p class="day text-uppercase">
                            Alumnos de Nuevo Ingreso
                        </p>
                    </div>
                    <div class="col-md-5 my-auto">
                        <p>
                            Primer corte de pago: 7 de octubre de 2025
                        </p>
                        <p>
                            Fecha límite de pago: 15 de octubre de 2025
                        </p>
   
                    </div>


                </div>
            </div>
        </div>
    </div>
</section>